<template>
<div class="main list-view no-sidebar">

    <div v-if="!showDetail">

		<div class="sub-header">
			<div class="input-with-control">
				<input type="search" ref="search_term" v-model="searchTerm" placeholder="Search..." @search="doSearch()" v-focus>
				<div class="button action input-go" @click="doSearch()"><i class="fas fa-search"></i></div>
				<label style='position: absolute; left: 102%; top: 0.5em; width: 30em;'>Search for a UPC or product description.</label>
			</div>
			<div class="controls">
				<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
			</div>
		</div>

        <loading v-if="loading">Finding duplicates...</loading>
        <div v-else class="list" style="margin: 0 3em;">
            <div v-if="list.length == 0" class="empty-list">
                This list is empty
            </div>
            <div v-else>
                <table class="data-list">
                    <thead>
                        <tr>
                            <th></th>
                            <th>UPC</th>
                            <th>Description</th>
                            <th class="center">Duplicates</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(duplicate, index) in list" class="clickable-list-item" @click="getDetail(duplicate.upc)">
                            <td class="center tiny-image"><img :src="duplicate.image_src" /></td>
                            <td>{{ duplicate.upc }}</td>
                            <td>{{ duplicate.description }}</td>
                            <td class="center">{{ duplicate.duplicates }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div v-if="showDetail">
        <loading v-if="loading"></loading>
        <div v-else class="detail duplicate-detail">

            <div>
                <h3>Duplicates for UPC {{ duplicateUPC }}</h3>
                <div v-for="duplicate, index) in duplicates" class="duplicate-list">
                    <div class="duplicate-row-heading">
                        <div><label>ID</label><span>{{ duplicate.product_id }}</span></div><div></div>
                        <div><label>Owner</label><span>{{ duplicate.client_id == clientId ? 'Store' : 'Distributor'}}</span></div>
                    </div>
                    <img class="duplicate-row-image" :src="duplicate.image_src" />
                    <div class="duplicate-row-specs">
                        <label>Model</label><span>{{ duplicate.model }}</span>
                        <label>SKU</label><span>{{ duplicate.sku }}</span>
                        <label>Mfg</label><span>{{ duplicate.manufacturer }}</span>
                        <label>Caliber</label><span>{{ duplicate.caliber }}</span>
                    </div>
                    <div>
                        <label>Description</label>
                        <div style="margin: 0 0 1em 0;">{{ duplicate.description }}</div>
                        <label>Detailed Description</label>
                        <div v-html="duplicate.detailed_description"></div>
                    </div>
                    <div>
                        <div v-if="!inMerge(duplicate.product_id)" class="button action" @click="addToMerge(duplicate)"><i class="fas fa-chevron-right"></i></div>
                        <div v-else class="button delete" @click="removeFromMerge(duplicate)"><i class="fas fa-chevron-left"></i></div>
                    </div>
                </div>
            </div>

            <div class="merged">
                <h3>Your merged product</h3>
                <div v-if="merge.product_id">
                    <img class="duplicate-row-image" :src="merge.image_src" />
                    <div class="duplicate-row-specs">
                        <label>Model</label><span>{{ merge.model }}</span>
                        <label>SKU</label><span>{{ merge.sku }}</span>
                        <label>Mfg</label><span>{{ merge.manufacturer }}</span>
                        <label>Caliber</label><span>{{ merge.caliber }}</span>
                    </div>
                    <div style="margin: 1em 0 0 0;">
                        <label>Description</label>
                        <div>{{ merge.description }}</div>
                        <label>Detailed Description</label>
                        <div v-html="merge.detailed_description" style="margin: 1em 0 0 0;"></div>
                    </div>
                    <div class="note" style="padding: 1em 0; border-top: 1px dotted #666;" v-if="distributorProductInMerge && merges.length > 1 && this.getUser.user_type_code.indexOf('ADMIN') < 0">
                        <i class="fas fa-exclamation-triangle"></i> This merge includes a distributor product. <i class="fas fa-info-circle pointer" @click="showDistributorProductAlert = !showDistributorProductAlert"></i>
                        <div v-if="showDistributorProductAlert" style="margin: 1em 0 0 1.5em;">
                            <p>Merging your custom products with a distributor product is allowed.</p>
                            <p>Your prices and store availability will be attached to the distributor product, but item info will no longer be editable.</p>
                        </div>
                    </div>
                </div>
                <div v-else class="empty-list">
                    Nothing merged yet
                </div>
            </div>
        </div>

        <div class="controls wide" style="margin: 0;">
            <div class="button cancel spaced" @click="backToList()">Cancel</div>
            <div :class="['button', 'spaced', merges.length > 1 ? 'action' : 'disabled']" @click="showModal = true">Merge {{ merges.length }} Product{{ merges.length == 1 ? "" : "s" }}</div>
        </div>
    </div>

	<div class="modal" v-if="showModal">
		<div class="inner">
			<h2>Confirm Merge Products</h2>
			<div class="content" style="width: 33em; height: 12em;">
                <loading v-if="merging">Merging</loading>
				<p v-else style="padding: 2em 0; font-size: 1.5em; text-align: center;">You are about to merge {{ merges.length }} products.<br />This cannot be undone.</p>
			</div>
			<div class="controls">
                <div class="button cancel spaced" @click="cancelMerge()">Cancel</div>
				<div :class="['button', 'spaced', merging ? 'disabled' : 'action']" @click="saveMerge()">Do Merge</div>
                <div class="note" v-if="modalMessage">{{ modalMessage }}</div>
			</div>
		</div>
	</div>

    <help-popup :helpLink="{156:'Merge Duplicate Products'}" :tours="false"></help-popup>


</div>
</template>

<script>
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'merge-products',
    components: {
		'help-popup': HelpPopup
    },
	data() {
		return {
            loading: false,
			clientId: '',
            duplicatesRequested: false,
            searchTerm: '',
			list: [],
            page: 1,
			paging: {},
            duplicateUPC: '',
            duplicates: [],
            merges: [],
            merge: {},
			showDetail: false,
            distributorProductInMerge: false,
            showDistributorProductAlert: false,
            showModal: false,
            modalMessage: '',
            merging: false
		}
	},
    created() {
        this.getList()
    },
    computed: {
		showPagination() {
			return this.paging.total_pages
		},

    },
	methods: {
		getList() {
            if (this.loading) { return }
            this.loading = true
			this.showDetail = false
			this.apiCall({ destination: 'get_list_product_duplicates', data: { page: this.page, search_term: this.searchTerm } }).then(obj => {
                this.duplicatesRequested = true
                this.loading = false
				this.list = obj.list
				this.clientId = obj.client_id
                this.paging = obj.paging
			}).catch(err => {
                this.loading = false
				console.log(err)
			})
		},
		doSearch() {
			this.page = 1
			this.getList()
		},
		goToPage(page) {
			this.page = page
			this.getList()
		},
		getDetail(upc) {
            this.duplicateUPC = upc
			this.showDetail = true
			this.loading = true
			this.apiCall({ destination: 'get_item_product_duplicates', data: { upc: upc } }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.clientId = obj.client_id
					this.duplicates = obj.duplicates
				}
			}).catch(err => {
				console.log(err)
				this.loading = false
			})
		},
        inMerge(productId) {
            for (let i = 0; i < this.merges.length; i++) {
                if (this.merges[i].product_id == productId) {
                    return true
                }
            }
            return false
        },
        addToMerge(duplicate) {
            this.merges.push(duplicate)
            this.collateMerge()
        },
        removeFromMerge(duplicate) {
            for (let i = 0; i < this.merges.length; i++) {
                if (this.merges[i].product_id == duplicate.product_id) {
                    this.merges.splice(i, 1)
                    break;
                }
            }
            this.collateMerge()
        },
        collateMerge() {
            // first are there any distributor products in the list
            this.merge = {}
            this.distributorProductInMerge = false
            for (let i = 0; i < this.merges.length; i++) {
                if (!this.merges[i].client_id) {
                    this.merge = this.merges[i]
                    this.distributorProductInMerge = true
                    break;
                }
            }
            // if merge is not a distributor product
            if (!this.distributorProductInMerge) {
                for (let i = 0; i < this.merges.length; i++) {
                    for (const property in this.merges[i]) {
                        this.merge[property] = this.merge[property] || this.merges[i][property]
                    }
                }
            }
        },
        saveMerge() {
            if (this.merging) { return }
			this.merging = true
			this.apiCall({ destination: 'save_item_product_merge', data: { master: this.merge, merges: this.merges } }).then(obj => {
				this.merging = false
                this.modalMessage = obj.message
				if (obj.status == 'success') {
                    this.backToList(true)
				}
			}).catch(err => {
				console.log(err)
				this.merging = false
			})

        },
        cancelMerge() {
            if (!this.merging) {
                this.modalMessage = ''
                this.showModal = false
            }
        },
		backToList(reload) {
            this.cancelMerge()
			this.showDetail = false
			this.duplicates = []
			this.merges = []
            this.merge = {}
            if (reload) {
                this.getList()
            }
		}
	}
}
</script>

<style lang="scss" scoped>
.duplicate-detail {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-gap: 5em;
    align-items: start;
}
.controls.wide {
    margin: 1em 0 1em 0;
    padding: 1em 0 0 0;
    border-top: 1px dotted #666;
    text-align: center;
}
.duplicate-list {
    display: grid;
    grid-template-columns: 7em 1fr 2fr 2.5em;
    grid-column-gap: 2em;
    margin: 0 0 1em 0;
}
.duplicate-row-heading {
    grid-column: span 4;
    background-color: #ccc;
    padding: 0.5em;
    margin: 0 0 1em 0;
    display: grid;
    grid-template-columns: 7em 1fr 2fr 2.5em;
    font-weight: bold;
    label { padding: 0 1em 0 0; }
}
.duplicate-row-image {
    max-width: 100%;
}
.duplicate-row-specs {
    display: grid;
    grid-template-columns: 1fr 3fr;
    grid-gap: 0.5em;
}
</style>
